import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { closeTimerData } from 'src/app/public/fullscreen-timer/fullscreen-timer.component';

@Component({
  selector: 'app-close-timer-confirmation',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './close-timer-confirmation.component.html',
  styleUrl: './close-timer-confirmation.component.css'
})
export class CloseTimerConfirmationComponent {
  readonly data = inject<closeTimerData>(MAT_DIALOG_DATA);
  
  constructor(private dialogRef: MatDialogRef<CloseTimerConfirmationComponent>) {
  }
  confirmed(){
    this.dialogRef.close(true);
  }
}
